import moment from 'moment';

function createMomentDateWithFixedOffset(dateStr) {
    const m = moment(dateStr);
    m.utcOffset(dateStr,false);
    // console.log("utcOffset", m.utcOffset(), dateStr, m.format('DD.MM.YYYY HH:mm'))
    return m;
}

export {createMomentDateWithFixedOffset}